<div id="sidebar-collapse">
  <!-- IF Account HAVE 1 or more company linked -->
        <ul  class="side-menu metismenu">
        <li>
          <!--a routerLink="/dashboard" routerLinkActive="active">
            <i class="sidebar-item-icon ti-view-grid"></i>
            <span class="nav-label">Dashboard</span>
          </a-->
          <a routerLink="/admin/company" routerLinkActive="active">
            <i class="sidebar-item-icon ti-view-grid"></i>
            <span class="nav-label">Company</span>
          </a>
        </li>
        <li >
          <a routerLink="/admin/wallet" routerLinkActive="active">
            <i class="sidebar-item-icon ti-id-badge"></i>
            <span class="nav-label">Wallet Preview</span>
          </a>
        </li>
        <li >
          <a routerLink="/admin/user" routerLinkActive="active">
            <i class="sidebar-item-icon ti-id-badge"></i>
            <span class="nav-label">Portal Users</span>
          </a>
        </li>
        <li >
          <a routerLink="/admin/zuser" routerLinkActive="active">
            <i class="sidebar-item-icon ti-id-badge"></i>
            <span class="nav-label">App Users</span>
          </a>
        </li>
        <li *ngIf="billingenable">
          <a routerLink="/admin/subscription" routerLinkActive="active">
            <i class="sidebar-item-icon ti-user"></i>
            <span class="nav-label">Subscription</span>
            </a>
        </li>
        <!--li *ngIf="billingenable">
          <a routerLink="/admin/zhealthcard" routerLinkActive="active">
            <i class="sidebar-item-icon ti-user"></i>
            <span class="nav-label">ZHealthCard</span>
            </a>
        </li -->
        <!--li>
          <a routerLink="/company/{{compid}}/department" routerLinkActive="active">
            <i class="sidebar-item-icon ti-tag"></i>
            <span class="nav-label">Other</span>
          </a>
        </li -->
        <li>
          <a routerLink="/admin/gen-invoice" routerLinkActive="active">
            <i class="sidebar-item-icon ti-tag"></i>
            <span class="nav-label">Generate Invoice</span>
          </a>
        </li>

        <li>
          <a routerLink="/admin/sendmail" routerLinkActive="active">
            <i class="sidebar-item-icon ti-tag"></i>
            <span class="nav-label">Send Email</span>
          </a>
        </li>
       
        
      </ul>
  

    <!-- IF Account do not have ANY company linked -->
  
</div>